import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase';

export const useGenres = () => {
  const [genres, setGenres] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Load genres from Supabase
  const loadGenres = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const { data, error } = await supabase
        .from('genres')
        .select('*')
        .order('name');

      if (error) {
        console.error('Error fetching genres:', error);
        setError(error.message);
        return [];
      }

      console.log('Loaded genres:', data);
      setGenres(data || []);
      return data || [];
    } catch (err) {
      console.error('Error loading genres:', err);
      setError(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  // Load genres on hook initialization
  useEffect(() => {
    loadGenres();
  }, [loadGenres]);

  return {
    genres,
    loading,
    error,
    loadGenres
  };
};
